module.exports = __webpack_public_path__ + "static/img/receive.119db3d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/receive.gif
// module id = GCVz
// module chunks = 0